import React from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { RoundButton } from '../../app/components';

const imageSource = {
  beginDrag(props) {
    return {
      id: props.id,
      originalIndex: props.findImage(props.id).index,
      backgroundImage: `url(${props.previewUrl.value})`,
    };
  },
  endDrag(props, monitor) {
    const { id: droppedId, originalIndex } = monitor.getItem();
    const didDrop = monitor.didDrop();
    if (!didDrop) {
      props.onMoveImage(droppedId, originalIndex);
    }
  },
};

const imageTarget = {
  canDrop() {
    return false;
  },
  hover(props, monitor) {
    const { id: draggedId } = monitor.getItem();
    const { id: overId } = props;
    if (draggedId !== overId) {
      const { index: overIndex } = props.findImage(overId);
      props.onMoveImage(draggedId, overIndex);
    }
  },
};

function collectSource(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

function collectTarget(connect) {
  return {
    connectDropTarget: connect.dropTarget(),
  };
}

let ImageItem = ({
  previewUrl, onDeselectImage, isDragging, connectDragSource, connectDropTarget,
}) => {
  const opacity = isDragging ? 0.5 : 1;

  return connectDragSource(connectDropTarget(
    <div
      className="image"
      style={{ opacity, backgroundImage: `url(${previewUrl.value})` }}
    >
      <RoundButton
        content={
          <span className="icon-close-shadow" />
        }
        disabled={false}
        color="#ffffff"
        borderColor="#ff3758"
        backgroundColor="#ff3758"
        flat={false}
        onClick={e => onDeselectImage(e, previewUrl.key)}
      />
    </div>,
  ));
};

ImageItem.propTypes = {
  connectDragSource: React.PropTypes.func.isRequired,
  connectDropTarget: React.PropTypes.func.isRequired,
  onMoveImage: React.PropTypes.func.isRequired,
  findImage: React.PropTypes.func.isRequired,
  id: React.PropTypes.any.isRequired,
  isDragging: React.PropTypes.bool.isRequired,
  previewUrl: React.PropTypes.object.isRequired,
  onDeselectImage: React.PropTypes.func.isRequired,
};

ImageItem = DropTarget('image', imageTarget, collectTarget)(ImageItem);
export default DragSource('image', imageSource, collectSource)(ImageItem);



// WEBPACK FOOTER //
// ./src/browser/steps/ImagesStep/ImageItem.js